import Vue from 'vue';
import './plugins/localstorage';
import './plugins/highcharts';
import './plugins/axios';
import './plugins/vuetify';
import 'animate.css';
import './plugins/veeValidate';
import './plugins/clipboard';
import './plugins/noty';
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import {sync} from 'vuex-router-sync'
import router from './router'
import store from './store'
import App from './components/App'
// import './plugins/firesbase';

window.Vue = Vue;
// event bus
Vue.prototype.$bus = new Vue;


const unsync = sync(store, router);

const app = new Vue({
    router,
    store,
    ...App
}).$mount('#app');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js